import React, { useEffect, useState } from 'react';
import { adminSideBarList } from '../constatnts/ConstantsSideBar';
import { ReactComponent as CloseModalIcon } from '../assets/svg/CloseModalIcon.svg';
import { useUser } from '../auth/UseUser';
import { useNavigate } from 'react-router-dom';

function SideBarBigScreen({ toggleSideBar, backbutton = false, isOpen = true }: any) {
    const { isAdminApp } = useUser();
    const navigate = useNavigate();

    const currentPath = window.location.pathname;

    return (
        <div className={`h-full ${isOpen ? 'min-w-[260px]' : 'w-0'} absolute top-0 left-0  lg:static lg:min-w-[260px] transition-all`}>
            <div className="w-full h-full overflow-y-auto gray-small-scroll bg-blueMedium">
                <div className="flex flex-row items-center justify-between mt-5 px-5">
                    <div
                        className={`${backbutton ? '' : 'invisible'} lg:invisible`}
                        onClick={() => {
                            toggleSideBar();
                        }}
                    >
                        <CloseModalIcon />
                    </div>
                    <p className="text-center text-white text-[18px] leading-5">Meni</p>
                    <div className="invisible">
                        <CloseModalIcon />
                    </div>
                </div>
                {isAdminApp && (
                    <div>
                        {adminSideBarList.map((item: any, index: number) => {
                            return (
                                <div
                                    className={`w-full h-[50px] flex flex-row items-center px-5 cursor-pointer transition ${
                                        !!item?.url && currentPath.includes(item?.url)
                                            ? 'bg-blueLight text-beeYellow'
                                            : 'bg-blueMedium text-white hover:bg-blueLight'
                                    }`}
                                    key={index}
                                    onClick={() => navigate(item?.url)}
                                >
                                    <p className=" text-[18px] leading-6">{item.title}</p>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
}

export default SideBarBigScreen;
